

const ErrorPage = () => {
    return (
        <div className="main">ERRO!</div>
    )
}

export default ErrorPage;